import ConditionsUpsellModal from './ConditionsUpsellModal';

export default ConditionsUpsellModal;
